import { Box, Button, Card, Image, Typography, useMediaQueryContext } from "@drone-js/core";
import type { FunctionComponent, PropsWithChildren } from "react";
import { PartnerMarketingLayout } from "./PartnerMarketingLayout";
import { usePartnerMarketingModelValue } from "./partnerMarketingModelAtom";

import "./contactUs.css";

export const PARTNERHUB_SUPPORT_PAGE_URL = "https://partnerhub.agoda.com/contacting-us-for-support/";
const IMAGE_BASE_URL = "https://cdn6.agoda.net/images/agoda-homes/partner-marketing";
const ContactUsContainer: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const mediaQuery = useMediaQueryContext();
    return mediaQuery.m ? (
        <Box display="flex" flexDirection="row" gap="24" p="24" justifyContent="space-between">
            {children}
        </Box>
    ) : (
        <div className="contact-us-container">
            <Box p="24">{children}</Box>
        </div>
    );
};

export const ContactUs: FunctionComponent = () => {
    const {
        contactUsViewModel: { contactUsTitle, contactUsText, contactUsButtonLabel },
        shouldUseOptimizedImages,
    } = usePartnerMarketingModelValue();

    const mediaQuery = useMediaQueryContext();

    return (
        <section id="contact-us-section">
            <Box py="64">
                <PartnerMarketingLayout col={10} data-element-name="support-section">
                    <Card type="non-interactive" variant="outlined" width="100%">
                        <ContactUsContainer>
                            <Box display="flex" flexDirection="column" gap="24">
                                <Typography variant="heading-default">{contactUsTitle}</Typography>
                                <Typography variant="body-default" textColor="base.subtle">
                                    {contactUsText}
                                </Typography>
                                <Box width="fit-content">
                                    <Button
                                        variant="label"
                                        label={contactUsButtonLabel}
                                        href={PARTNERHUB_SUPPORT_PAGE_URL}
                                        target="_blank"
                                        data-element-name="partner-marketing-contact-us"
                                    />
                                </Box>
                            </Box>
                            {mediaQuery.m &&
                                (shouldUseOptimizedImages ? (
                                    <picture>
                                        <source
                                            srcSet={`${IMAGE_BASE_URL}/contactus-section-v2/AgentIcon.webp`}
                                            type="image/webp"
                                        />
                                        <Image
                                            src={`${IMAGE_BASE_URL}/contactus-section-v2/AgentIcon.png`}
                                            loading="lazy"
                                            alt="AgodaAgentIcon"
                                            width="140px"
                                            height="140px"
                                        />
                                    </picture>
                                ) : (
                                    <Image
                                        src={`${IMAGE_BASE_URL}/contactus-section/AgentIcon.png`}
                                        loading="lazy"
                                        alt="AgodaAgentIcon"
                                        width="140px"
                                        height="140px"
                                    />
                                ))}
                        </ContactUsContainer>
                    </Card>
                </PartnerMarketingLayout>
            </Box>
        </section>
    );
};
